// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closeModalBtn[data-v-b98064ec] {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  text-align: center;\n}\n.closeModalBtn i[data-v-b98064ec] {\n    font-size: 16px;\n    color: #999999;\n}\n", ""]);
// Exports
module.exports = exports;
